import { render, staticRenderFns } from "./loginwithtelegram.vue?vue&type=template&id=acacf98e&"
import script from "./loginwithtelegram.vue?vue&type=script&lang=js&"
export * from "./loginwithtelegram.vue?vue&type=script&lang=js&"
import style0 from "./loginwithtelegram.vue?vue&type=style&index=0&id=acacf98e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VContainer,VImg,VRow})
